import React from 'react';
import { Box, Stack } from '@mui/material';
import { Controller } from 'react-hook-form';
import HoursSelect from './HoursSelect';
import MinutesSelect from './MinutesSelect';
import { WorkingTimeInputsProps, ControlProps } from './interfaces';

export default function WorkingTimeInputs(props: WorkingTimeInputsProps) {
  const isControlProps = (
    selectProps: WorkingTimeInputsProps,
  ): selectProps is ControlProps =>
    (selectProps as ControlProps).control !== undefined;

  if (isControlProps(props)) {
    const { control } = props;

    return (
      <Stack direction="row" spacing={3}>
        <Box display="flex" alignItems="center" flexBasis="50%">
          <Controller
            name="hoursPerWeek"
            control={control}
            render={({ field: { value, onChange } }) => (
              <HoursSelect value={value} onChange={onChange} type="perWeek" />
            )}
          />
          <Controller
            name="minutesPerWeek"
            control={control}
            render={({ field: { value, onChange } }) => (
              <MinutesSelect value={value} onChange={onChange} />
            )}
          />
        </Box>
        <Box display="flex" alignItems="center" flexBasis="50%">
          <Controller
            name="jobSizeHours"
            control={control}
            render={({ field: { value, onChange } }) => (
              <HoursSelect value={value} onChange={onChange} type="jobSize" />
            )}
          />
          <Controller
            name="jobSizeMinutes"
            control={control}
            render={({ field: { value, onChange } }) => (
              <MinutesSelect value={value} onChange={onChange} />
            )}
          />
        </Box>
      </Stack>
    );
  }

  const {
    hoursPerWeek,
    minutesPerWeek,
    jobSizeMinutes,
    jobSizeHours,
    onHoursPerWeekChange,
    onJobSizeHoursChange,
    onJobSizeMinutesChange,
    onMinutesPerWeekChange,
  } = props;

  return (
    <Stack direction="row" spacing={3}>
      <Box display="flex" alignItems="center" flexBasis="50%">
        <HoursSelect
          value={hoursPerWeek}
          onChange={onHoursPerWeekChange}
          type="perWeek"
        />
        <MinutesSelect
          value={minutesPerWeek}
          onChange={onMinutesPerWeekChange}
        />
      </Box>
      <Box display="flex" alignItems="center" flexBasis="50%">
        <HoursSelect
          value={jobSizeHours}
          onChange={onJobSizeHoursChange}
          type="jobSize"
        />
        <MinutesSelect
          value={jobSizeMinutes}
          onChange={onJobSizeMinutesChange}
        />
      </Box>
    </Stack>
  );
}
